// @flow
interface LiveMetrics {
    nbOfConnections: number;
    streamStatus: string;
    bitrate: number;
    error: boolean;
}

export default class StreamLiveMetrics {

  nbOfConnections: number;
  streamStatus: string;
  bitrate: number;
  error: boolean;

  constructor(data: LiveMetrics) {
    this.nbOfConnections = data.nbOfConnections;
    this.streamStatus = data.streamStatus;
    this.bitrate = data.bitrate;
    this.error = data.error;
  }

  static parse(data: Object) {
    return new StreamLiveMetrics(data);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/streaming/domain/StreamLiveMetrics.js